import ReactDOM from 'react-dom';
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';

const FundListComponent = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  useEffect(() => {
    fetchData();
  }, [first, rows]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${fundListPluginSettings.apiUrl}api/v1/fund/summary?page=${Math.ceil((first + 1) / rows)}&per_page=${rows}&sort_by=Net Asset Value&sort_order=-1`);
      console.log("response.data", response.data);
      setData(response.data.items);
      setTotalRecords(response.data.count);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const onPageChange = event => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <div>
      <DataTable
        value={data}
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        rows={rows}
        totalRecords={totalRecords}
        loading={loading}
        onPage={onPageChange}
      >
        <Column field="Scheme Code" header="Scheme Code" sortable />
        <Column field="Scheme Name" header="Scheme Name" sortable />
        <Column field="Average NAV" header="Average NAV" sortable />
        {/* <Column field="category_name" header="Category" sortable /> */}
        {/* <Column field="provider_name" header="Provider" sortable /> */}
        <Column field="Net Asset Value" header="Net Asset Value" sortable />
        {/* <Column field="ISIN Div Payout/ ISIN Growth" header="ISIN" sortable /> */}
        {/* Add more columns as needed */}
      </DataTable>
    </div>
  );
};

export default FundListComponent;
